import { User } from '../../auth/authState';
import { APP_NAME } from '../../appName';

const userHasPermission = (
  user: User | null,
  requiredRoles: string | string[],
  matchMode: 'ALL' | 'ANY' = 'ANY'
) => {
  if (!user) {
    return false;
  }

  const userRoles = user.roles ?? [];

  const rolesArray = Array.isArray(requiredRoles)
    ? requiredRoles
    : [requiredRoles];

  return matchMode === 'ALL'
    ? rolesArray.every((r) => userRoles.includes(`${APP_NAME}/${r}`))
    : rolesArray.some((r) => userRoles.includes(`${APP_NAME}/${r}`));
};

export default userHasPermission;
